import axios from "axios";
import { ALL_DASHBOARD_BILLING_CHART_FAIL, ALL_DASHBOARD_BILLING_CHART_REQUEST, ALL_DASHBOARD_BILLING_CHART_SUCCESS, ALL_DASHBOARD_CHART_FAIL, ALL_DASHBOARD_CHART_REQUEST, ALL_DASHBOARD_CHART_SUCCESS, ALL_DASHBOARD_LINE_CHART_FAIL, ALL_DASHBOARD_LINE_CHART_REQUEST, ALL_DASHBOARD_LINE_CHART_SUCCESS, CARRIER_METRICS_REQUEST, CARRIER_METRICS_SUCCESS, CARRIER_METRICS_FAIL, TOP_CARRIERS_WIDGET_REQUEST, TOP_CARRIERS_WIDGET_SUCCESS, TOP_CARRIERS_WIDGET_FAIL } from "../constants/adminPortal_dashboardConstants";
import { toast } from "react-toastify";
import { api } from "../../mockData";

export const getDashboardChart = () => async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("admin"));
      try {
        dispatch({ type: ALL_DASHBOARD_CHART_REQUEST });
        let config = {
          method: "get",
          maxBodyLength: Infinity,
          url: `${api.dev}/api/serverstats`,
          headers: {
            "Content-Type": "application/json",
            "Authorization" : `Bearer ${token.access_token} `
          },
        };
        await axios
          .request(config)
          .then((response) => {
            // /api/serverstats now returns a NESTED shape:
            //   { cpu: { usage_percent }, memory: { ... }, disk: { ... }, ssl }
            // The legacy Cpuchart / Memoryusage / Diskusage components on the
            // admin Settings → Server Stats page still read FLAT keys
            // (cpu_usage_per / memory_usage_per / disk_usage_per). To keep
            // the old page working without touching each chart component,
            // we flatten here — preserves the new nested fields too so any
            // newer consumer that wants `data.cpu.cores` still gets them.
            const raw = response?.data?.data || {};
            const flattened = {
              ...raw,
              cpu_usage_per: raw?.cpu?.usage_percent ?? 0,
              memory_usage_per: raw?.memory?.usage_percent ?? 0,
              disk_usage_per: raw?.disk?.usage_percent ?? 0,
            };
            dispatch({
              type: ALL_DASHBOARD_CHART_SUCCESS,
              payload: flattened,
            });
          })
          .catch((error) => {
            let errorMessage = "An error occurred while fetching data.";
            if (error.response) {
              if (error.response.status === 403) {
                errorMessage = "Permission Denied";
              } else if (error.response.status === 400 || error.response.status === 401 || error.response.status === 500) {
                errorMessage = error.response.data.message || "Bad Request";
              }
            }
            dispatch({ type: ALL_DASHBOARD_CHART_FAIL, payload: errorMessage });
          });
      } catch (error) {
        dispatch({ type: ALL_DASHBOARD_CHART_FAIL, payload: error.response.data.message });
      }
    };
    export const getDashboardBillingChart = () => async (dispatch) => {
      const token = JSON.parse(localStorage.getItem("admin"));
        try {
          dispatch({ type: ALL_DASHBOARD_BILLING_CHART_REQUEST });
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `${api.dev}/api/billingstats`,
            headers: {
              "Content-Type": "application/json",
              "Authorization" : `Bearer ${token.access_token} `
            },
          };
          await axios
            .request(config)
            .then((response) => {
              dispatch({
                type: ALL_DASHBOARD_BILLING_CHART_SUCCESS,
                payload: response?.data?.data,
              });
            })
            .catch((error) => {
              if (error.response && error.response.data.status === 403) {
                dispatch({ type: ALL_DASHBOARD_BILLING_CHART_FAIL, payload: "Permission Denied" });
              } else if (error.response && error.response.data && error.response.data.message) {
                dispatch({ type: ALL_DASHBOARD_BILLING_CHART_FAIL, payload: error.response.data.message });
              } else {
                dispatch({ type: ALL_DASHBOARD_BILLING_CHART_FAIL, payload: "An error occurred while fetching data." });
              }
            });
        } catch (error) {
          dispatch({ type: ALL_DASHBOARD_BILLING_CHART_FAIL, payload: error.response.data.message });
        }
      };

      export const getDashboardLineChart = () => async (dispatch) => {
        const token = JSON.parse(localStorage.getItem("admin"));
          try {
            dispatch({ type: ALL_DASHBOARD_LINE_CHART_REQUEST });
            let config = {
              method: "get",
              maxBodyLength: Infinity,
              url: `${api.dev}/api/generate_ACD_ASR_chart`,
              headers: {
                "Content-Type": "application/json",
                "Authorization" : `Bearer ${token.access_token} `
              },
            };
            await axios
              .request(config)
              .then((response) => {
                dispatch({
                  type: ALL_DASHBOARD_LINE_CHART_SUCCESS,
                  payload: response?.data,
                });
              })
              .catch((error) => {
                if (error.response && error.response.data.status === 403) {
                  dispatch({ type: ALL_DASHBOARD_LINE_CHART_FAIL, payload: "Permission Denied" });
                } else if (error.response && error.response.data && error.response.data.message) {
                  dispatch({ type: ALL_DASHBOARD_LINE_CHART_FAIL, payload: error.response.data.message });
                } else {
                  dispatch({ type: ALL_DASHBOARD_LINE_CHART_FAIL, payload: "An error occurred while fetching data." });
                }
              });
          } catch (error) {
            dispatch({ type: ALL_DASHBOARD_LINE_CHART_FAIL, payload: error.response.data.message });
          }
        };

      export const getCarrierMetrics = (startDate, endDate, carrier) => async (dispatch) => {
        const token = JSON.parse(localStorage.getItem("admin"));
        try {
          dispatch({ type: CARRIER_METRICS_REQUEST });
          const params = new URLSearchParams();
          if (startDate) params.append("start_date", startDate);
          if (endDate) params.append("end_date", endDate);
          if (carrier) params.append("carrier", carrier);
          const queryString = params.toString();

          let config = {
            method: "get",
            url: `${api.dev}/api/carrier_metrics${queryString ? "?" + queryString : ""}`,
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token.access_token}`
            },
          };
          await axios
            .request(config)
            .then((response) => {
              dispatch({
                type: CARRIER_METRICS_SUCCESS,
                payload: response?.data,
              });
            })
            .catch((error) => {
              const msg = error?.response?.data?.message || "An error occurred while fetching carrier metrics.";
              dispatch({ type: CARRIER_METRICS_FAIL, payload: msg });
            });
        } catch (error) {
          dispatch({ type: CARRIER_METRICS_FAIL, payload: error?.response?.data?.message || "Failed to fetch carrier metrics" });
        }
      };

      // Top 4 Carriers widget — same /api/carrier_metrics endpoint, but
      // calls it with a `source` param so the widget can show three different
      // ranking views (DID supplier / outbound termination trunk / caller's
      // mobile network). State is cached per source in topCarriersWidget so
      // tab switches don't refetch unnecessarily.
      export const getTopCarriersWidget = (source, startDate, endDate) => async (dispatch) => {
        const token = JSON.parse(localStorage.getItem("admin"));
        try {
          dispatch({ type: TOP_CARRIERS_WIDGET_REQUEST, source });
          const params = new URLSearchParams();
          params.append("source", source);
          if (startDate) params.append("start_date", startDate);
          if (endDate) params.append("end_date", endDate);
          const queryString = params.toString();

          let config = {
            method: "get",
            url: `${api.dev}/api/carrier_metrics?${queryString}`,
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token.access_token}`
            },
          };
          await axios
            .request(config)
            .then((response) => {
              dispatch({
                type: TOP_CARRIERS_WIDGET_SUCCESS,
                source,
                payload: response?.data,
              });
            })
            .catch((error) => {
              const msg = error?.response?.data?.message || "An error occurred while fetching top carriers.";
              dispatch({ type: TOP_CARRIERS_WIDGET_FAIL, source, payload: msg });
            });
        } catch (error) {
          dispatch({ type: TOP_CARRIERS_WIDGET_FAIL, source, payload: error?.response?.data?.message || "Failed to fetch top carriers" });
        }
      };